import BaseUISystem from '../BaseUISystem';
import BaseMenu from './BaseMenu';
import { GameActions } from '../../../State/Game/GameActions';
import Game from '../../../Game';
import { PopupID } from '../../../State/UI/PopupID';

export default class PrePetMiniGameMenuHandler extends BaseMenu {
    constructor(uiSystem: BaseUISystem) {
        super(PopupID.PRE_PET_MINIGAME_MENU, uiSystem, false);
    }

    public onShow(params: unknown) {
        GameActions.loadMyPetMiniGame({});
    }
}
